import CryptoJS from "crypto-js";
import { jwtDecode } from "jwt-decode";
import { decryptToken } from "./getToken";

function isValidSessionId(v) {
  if (v == null) return false;
  const s = String(v).trim();
  return s.length > 0 && s !== "undefined" && s !== "null";
}

/** Tenant / admin main id: from decrypted user, then JWT (admin or staff). */
export const getSessionMainId = () => {
  const user = getDecryptedUserFromCookie();
  if (user) {
    const fromUser = user.main_id ?? user.user_id;
    if (isValidSessionId(fromUser)) return String(fromUser).trim();
  }
  const token = decryptToken("accessToken");
  if (!token) return null;
  try {
    const d = jwtDecode(token);
    if (isValidSessionId(d.user_id)) return String(d.user_id).trim();
    if (isValidSessionId(d.idold)) return String(d.idold).trim();
    if (isValidSessionId(d.userId)) return String(d.userId).trim();
  } catch (_) {
    /* ignore */
  }
  return null;
};

export const getDecryptedUserFromCookie = () => {
  try {
    const encryptedUser = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12eccom"));
    if (!encryptedUser) {
      console.warn("⚠️ No encrypted data found.");
      return null;
    }

    const secret = process.env.REACT_APP_CRYPTO_SECRET;
    if (!secret) {
      throw new Error("Missing REACT_APP_CRYPTO_SECRET");
    }

    const bytes = CryptoJS.AES.decrypt(encryptedUser, secret);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) throw new Error("Decryption returned empty string");

    return JSON.parse(decryptedText);
  } catch (err) {
    console.error("❌ Decryption or parsing failed:", err);
    return null;
  }
};
